import React from 'react'
import { useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'

import RoutesHelper from 'helpers/RoutesHelper'

import { getListName } from 'screens/Sidebar/NewSidebar/Items/Loaders/dataSync/fetchesChannelNotes'
import { getListState } from 'data'
import { NotePanelLoading } from 'components/Layout/AppLoading'

type RedirectToFirstNoteProps = {
  channelId: string
}

export function RedirectToFirstNote({ channelId }: RedirectToFirstNoteProps) {
  const firstNoteId = useSelector(function getFirstChannelNote(state) {
    const listName = getListName({ channelId })
    const listState = getListState(listName)(state)
    return listState && listState.nodes && listState.nodes[0]
  })

  return firstNoteId ? (
    <Redirect
      to={RoutesHelper.noteChannelShow({ channelId, noteId: firstNoteId })}
    />
  ) : (
    <NotePanelLoading />
  )
}
